import { Navigate, Route, Routes } from "react-router-dom";
import Flx from "../../components/layout/Flx";
import LoadingFallback from "../../components/LoadingFallback";
import { useReduxHook } from "../../hooks/useReduxHook";
import EndpointTesterRoute from "./EndpointTesterRoute";
import EndpointListRoute from "./EndpointListRoute";
import { isNil } from "lodash";
import MermaidChartDemo from "../../components/mermaid/MermaidChartDemo";
import MermaidChartRoute from "./MermaidChartRoute";

const DevScreen = () => {
  const { isDevUser, user } = useReduxHook();

  // Example payloads for quick testing
  if (isNil(user)) {
    return (
      <Flx center sx={{ p: 5 }}>
        <LoadingFallback />
      </Flx>
    );
  }

  if (!isNil(user) && !isDevUser) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route path={"/"} element={<EndpointListRoute />} />
      <Route path={"/endpoints"} element={<EndpointListRoute />} />
      <Route path={"/tester"} element={<EndpointTesterRoute />} />
      <Route path={"/mermaid"} element={<MermaidChartRoute />} />
    </Routes>
  );
};

export default DevScreen;
